export default __webpack_public_path__ + "static/media/825.5210514c.jpg";